import React from 'react';
import {
  Banco_BV,
  bank_account,
  bank_name_1,
  bank_name_10,
  bank_name_2,
  bank_name_3,
  bank_name_4,
  bank_name_5,
  bank_name_6,
  bank_name_7,
  bank_name_8,
  bank_name_9,
  Enter_bank_name,
  Enter_branch_name,
  getSubCategoryId,
  He_Letter,
  M_Letter,
  Metro_Bank,
  show_bank_search_filled_text,
  Step_2_Show,
} from '../../../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import FullPageSimulator from '../FullPagesComponents/FullPageSimulator';
import MenuManualRecipient from '../../ManulRecipient/MenuManualRecipient';
import AccountManuallyFP from '../FullPagesComponents/Services/Recipient/AccountManuallyFP';

const ToAccountManuallyDF = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  let showBranchSearch;
  const manualName = bank_account;
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const manual_recipient = globJSON.configurations.services[subCategoryId].recipient.manual_recipients[manualName];

  let showBankSearch = manual_recipient.search_from_list_bank;
  if (showBankSearch) {
    showBankSearch = manual_recipient.manual_fields_list.bank;
  }

  showBranchSearch = manual_recipient.search_from_list_branch_name;
  if (showBranchSearch) {
    showBranchSearch = manual_recipient.manual_fields_list.branch_name;
  }

  //---------------------------------------------------------------------
  const listName1 = [
    Banco_BV, show_bank_search_filled_text, bank_name_10, bank_name_1,
  ];
  const listName2 = [
    Metro_Bank, bank_name_2, bank_name_3,
  ];
  const listName3 = [
    bank_name_4, bank_name_5, bank_name_6, bank_name_7,
  ];
  const listName4 = [
    bank_name_8, bank_name_9,
  ];
    //---------------------------------------------------------------------

  return (
    <SimulatorsViewerArrangement>
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={manual_recipient.enter_details}
        withExtraHeightForTitle
        slideshowRefs={slideshowRefs}
      >
        <MenuManualRecipient
          globJSON={globJSON}
          simPlatform={simPlatform}
          manualName={manualName}
          subCategoryId={subCategoryId}
        />
      </FullPageSimulator>

      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={manual_recipient.enter_details}
        TopTitle={Step_2_Show}
        slideshowRefs={slideshowRefs}
      >
        <MenuManualRecipient
          globJSON={globJSON}
          simPlatform={simPlatform}
          manualName={manualName}
          subCategoryId={subCategoryId}
          isFormFilled
          toAddContactName={manual_recipient.save_to_list && manual_recipient.add_contact_name}
        />
      </FullPageSimulator>

      {!showBankSearch ? null : (
        <AccountManuallyFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          language={language}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
          listName={listName1}
          inputText={manual_recipient.search_bank}
          TopTitle={Enter_bank_name}
        />
      )}
      {!showBankSearch ? null : (
        <AccountManuallyFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          language={language}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
          listName={listName2}
          inputText={M_Letter}
          withCloseIcon
          withExtraHeightForTitle
        />
      )}
      {!showBranchSearch ? null : (
        <AccountManuallyFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          language={language}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
          listName={listName3}
          inputText={manual_recipient.search_branch}
          TopTitle={Enter_branch_name}
        />
      )}
      {!showBranchSearch ? null : (
        <AccountManuallyFP
          globJSON={globJSON}
          selectedScreen={selectedScreen}
          language={language}
          simPlatform={simPlatform}
          slideshowRefs={slideshowRefs}
          listName={listName4}
          inputText={He_Letter}
          withCloseIcon
          withExtraHeightForTitle
        />
      )}
    </SimulatorsViewerArrangement>
  );
};

export default ToAccountManuallyDF;
